export default __webpack_public_path__ + "static/东软-郭晓龙-9c2e039c457576d054ec1681e801b9ee.png";